module.exports = __webpack_public_path__ + "static/media/cpg_palbrush_logo_meet_kate.44951d75.png";